import React, { useEffect } from 'react';
import { FormLinkTracking } from 'Interfaces/overlayTracking';
import useTranslate from 'Hooks/useTranslate';
import useSignupFormTracking from 'Hooks/useSignupFormTracking';
import { useConfig } from 'AppShell/hooks';
import { TermsInfoText } from 'SharedComponents/styled/forms/TermsInfoText';

const TermsWrapperLinks: React.FunctionComponent = () => {
    const { t } = useTranslate();
    const config = useConfig();
    const { trackLinkClick } = useSignupFormTracking();
    const {
        links: { agb, dataProtection },
    } = config;

    useEffect(() => {
        const trackTermsOfService = () => trackLinkClick(FormLinkTracking.TermsOfServiceLink);

        const trackPrivacyPolicy = () => trackLinkClick(FormLinkTracking.PrivacyPolicyLink);

        const termsOfServiceElement = document.querySelector('.qa-login-signup-form__terms-link');
        if (termsOfServiceElement) {
            termsOfServiceElement.addEventListener('click', trackTermsOfService);
            termsOfServiceElement.addEventListener('auxclick', trackTermsOfService);
        }

        const privacyPolicyElement = document.querySelector('.qa-login-signup-form__privacy-policy-link');
        if (privacyPolicyElement) {
            privacyPolicyElement.addEventListener('click', trackPrivacyPolicy);
            privacyPolicyElement.addEventListener('auxclick', trackPrivacyPolicy);
        }
        return () => {
            if (termsOfServiceElement) {
                termsOfServiceElement.removeEventListener('click', trackTermsOfService);
                termsOfServiceElement.removeEventListener('auxclick', trackTermsOfService);
            }
            if (privacyPolicyElement) {
                privacyPolicyElement.removeEventListener('click', trackPrivacyPolicy);
                privacyPolicyElement.removeEventListener('auxclick', trackPrivacyPolicy);
            }
        };
    }, [trackLinkClick]);

    return (
        <TermsInfoText className="qa-login-signup-form__terms-ref">
            {t('signupOverlay_Our %sterms & conditions%s and %sPrivacy Policy%s apply', [
                `<a href="${agb}" target="_blank" class="qa-login-signup-form__terms-link">`,
                '</a>',
                `<a href="${dataProtection}" target="_blank" class="qa-login-signup-form__privacy-policy-link">`,
                '</a>',
            ])}
        </TermsInfoText>
    );
};

export default TermsWrapperLinks;
